import { Component, OnInit } from '@angular/core';
//import { Chart, registerables } from 'chart.js';

//import ChartDataLabels from 'chartjs-plugin-datalabels';

//  Chart.register(...registerables);

// Chart.register(...registerables,ChartDataLabels);


@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {

        // this.graph()
        // this.graph1()
    

}

// graph1(){
//   setTimeout(() => {
//     const canvas2 = document.getElementById('myChart2') as HTMLCanvasElement;
//     const ctx2 = canvas2.getContext('2d');

//     const myChart = new Chart(ctx2, {
//       type: 'line',
//       data: {
//         labels: ["Jan", "Feb", "March", "April", "May"],
//         datasets: [{
//           label: 'Total Earning',
//           data: [40, 50, 50,70,80],
//           borderColor: '#3590ae',
//           fill: true,
//           backgroundColor: '#e8f4f8',
//         }]
//       },
//       options: {
        
//         //indexAxis: 'y',
//         // responsive: true,
//         // maintainAspectRatio: false,
//         // onHover: (event, chartElement) => {
//         //   event.native.target['style'].cursor = chartElement[0] ? 'pointer' : 'default';
//         // },
//         // elements: {
//         //   bar: {
//         //     borderWidth: 2,
//         //   }
//         // },
//         // plugins: {
//         //   datalabels: {
//         //       anchor: 'end',
//         //       align: 'left',
//         //       clip: true,
//         //       offset: 0,
//         //       formatter: Math.round,
//         //       font: {
//         //           weight: 'bold',
//         //           size: 14
//         //       }
//         //   },
//         //   legend: {
//         //     display: false
//         //   }
//         // },
//         scales: {
//           y: {
//            // offset: false,
//             beginAtZero: true,
//             grid: {
//               display: false,
//               //  drawBorder: false,
//               // lineWidth: 0.5,
//             }

//           },
//           x: {
//             // ticks: {
//             //   display:false
//             // },
//             grid: {
//             // drawBorder: false,
//              display:false
//             }


//           }
//         },

//       }
//     });
//   }, 2000);


// }


// graph(){
//   setTimeout(() => {
//     const canvas1 = document.getElementById('myChart1') as HTMLCanvasElement;
//     const ctx = canvas1.getContext('2d');

//     const myChart = new Chart(ctx, {
//       type: 'bar',
//       data: {
//         labels: ["Jan", "Feb", "March", "April", "May"],
//         datasets: [{
//           label: 'Total Earning',
//           data: [30,40, 50, 60, 70],
//           backgroundColor: [
//             '#3d99d9',
//             '#F0FFFF',
//             '#00FFFF',
//             '#DAF7A6',
//             '#87CEEB'
//             // '#d9efff'
//           ],
//           borderRadius: 10,
//           barThickness: 20,
//           borderColor: 'rgba(255, 99, 132, 1)',
//           minBarLength: 2
//         }]
//       },
//       options: {
//         indexAxis: 'y',
//         // responsive: true,
//         // maintainAspectRatio: false,
//         onHover: (event, chartElement) => {
//           event.native.target['style'].cursor = chartElement[0] ? 'pointer' : 'default';
//         },
//         // elements: {
//         //   bar: {
//         //     borderWidth: 2,
//         //   }
//         // },
//         plugins: {
//           // datalabels: {
//           //     anchor: 'end',
//           //     align: 'left',
//           //     clip: true,
//           //     offset: 0,
//           //     formatter: Math.round,
//           //     font: {
//           //         weight: 'bold',
//           //         size: 14
//           //     }
//           // },
//           legend: {
//             display: false
//           }
//         },
//         scales: {
//           y: {
//            // offset: false,
//             beginAtZero: true,
//             grid: {
//               display: false,
//                drawBorder: false,
//               lineWidth: 0.5,
//              // drawOnChartArea:false
//             }

//           },
//           x: {
//             ticks: {
//              // display:false
//             },
//             grid: {
//              // display: false
//              //drawBorder: false,
             
//             }


//           }
//         },

//       }
//     });
//   }, 1000);
// }

}
